import { useError } from '@/hooks';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const ErrorToast = () => {
  const { error, dismissError } = useError();

  useEffect(() => {
    if (error.isVisible && error.message) {
      const toastOptions = {
        // position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: dismissError
      };

      switch (error.severity) {
        case 'warning':
          toast.warning(error.message, toastOptions);
          break;
        case 'info':
          toast.info(error.message, toastOptions);
          break;
        default:
          toast.error(error.message, toastOptions);
      }
    }
  }, [error.timestamp]);

  return null;
};
